import React, {useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import validator from 'validator'

// core components
import IndexNavbar from "components/Navbars/IndexNavbar";
import {useIsBusy} from "hooks/useBusy";
import {APIRequest} from "utils/ApiRequest";
import {toast} from "react-toastify";

function SignUpPage() {
  const [name, setName] = useState(null);
  const [email, setEmail] = useState(null);
  const [mobile, setMobile] = useState(null);
  const [password, setPassword] = useState(null);

  const history = useNavigate();
  const busy = useIsBusy();

  React.useEffect(() => {
    document.body.classList.add("login-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    let userInfo = localStorage.getItem('user-info');
    if (userInfo != null) {
      history("/index");
    }

    return function cleanup() {
      document.body.classList.remove("login-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleMobileChange = (e) => {
    setMobile(e.target.value);
  };

  function handleSignupSubmit() {
    if (busy) {
      return;
    }
    if ((email === null || email === "")
      || (password === null || password === "")
      || (mobile === null || mobile === "")
      || (name === null || name === "")) {
      toast.error('All fields are Mandatory!');
    }
    else if (!isValidEmail(email)) {
      toast.error('Email is invalid!');
    } else {
      APIRequest(
        null,
        "/signUp",
        {
          name, mobile, email, password
        },
        () => {
          toast.success('We have sent verfication email to your email address, please validate before login!');
          history("/login");
        },
        null,
        { busy: "Creating your account…", busyNote: "This can take a few seconds." }
      );
    }
  }

  function isValidEmail(email) {
    return validator.isEmail(email);
  }

  return (
    <>
      <IndexNavbar />
      <div className="hm-auth">
        <div className="hm-auth-card">
          <img
            className="hm-auth-logo"
            src={require("assets/img/now-logo.png")}
            alt="SORRBA"
          />
          <h1 className="hm-auth-title">Create your account</h1>
          <p className="hm-auth-sub">Join the SORRBA community</p>

          <label className="hm-auth-label" htmlFor="hm-name">
            Full name
          </label>
          <input
            id="hm-name"
            className="hm-auth-input"
            type="text"
            placeholder="Your full name"
            onChange={handleNameChange}
          />

          <label className="hm-auth-label" htmlFor="hm-email">
            Email
          </label>
          <input
            id="hm-email"
            className="hm-auth-input"
            type="email"
            placeholder="you@example.com"
            onChange={handleEmailChange}
          />

          <label className="hm-auth-label" htmlFor="hm-mobile">
            Mobile
          </label>
          <input
            id="hm-mobile"
            className="hm-auth-input"
            type="tel"
            placeholder="Your mobile number"
            onChange={handleMobileChange}
          />

          <label className="hm-auth-label" htmlFor="hm-password">
            Password
          </label>
          <input
            id="hm-password"
            className="hm-auth-input"
            type="password"
            placeholder="Choose a password"
            onChange={handlePasswordChange}
          />

          <button className="hm-auth-btn" onClick={handleSignupSubmit} disabled={busy}>
            {busy ? "Creating account…" : "Create account"}
          </button>

          <div className="hm-auth-links hm-auth-links-center">
            <Link to="/login">Already have an account? Log in</Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default SignUpPage;
